'use strict';

/**
 * View-level object providing notifications for current orders for the customer
 */
customerZone.service('OrderNotifications', ['OrderService', 'utils', '$location', '$q', '$log',
    function(OrderService, utils, $location, $q, $log){

        var self = this;

        var currentCustomerCode;

        /**
         * Do checks for the given customer code.  Invoking this automatically cancels the
         * checks for the previous customerCode, if any.
         */
        self.doCustomerChecks = function(customerCode){
            currentCustomerCode = customerCode;
            return OrderService.getPendingOrders()
                .then(function(orders){
                    if (currentCustomerCode !== customerCode) return;
                    notifyPaymentRequired(orders);
                    notifyActivationRequired(orders);
                    notifyMnpFailures(orders);
                });
        };

        var notifyPaymentRequired = function(pendingOrders){
            if (onPath('/my_orders', '/registration/sales', '/reload')) return;
            var awaitingOrders = pendingOrders.filter(byState(jim.OrderState.waiting_for_payment));
            if (awaitingOrders.length > 0)
                utils.showInfo(
                    utils.format(
                        'you_have_{number}_orders_still_awaiting_for_payment__link_to_order_overview',
                        {'number': awaitingOrders.length}
                    ), 'awaiting-orders'
                );
        };

        var notifyActivationRequired = function(pendingOrders){
            if (onPath('/registration/activate', '/registration/sales')) return;
            var activatableOrders = pendingOrders.filter(byState(jim.OrderState.waiting_for_sim_matching));
            if (activatableOrders.filter(byType(jim.OrderType.ORDER_A_SWAP)).length > 0)
                utils.showInfo('once_received_your_new_swap_sim_card_go_here_to_activate_your_sim', 'swap');
            if (activatableOrders.filter(byType(jim.OrderType.ORDER_A_SIM)).length > 0)
                utils.showInfo('once_received_your_new_sim_card_go_here_to_activate_your_sim', 'swap');
        };

        var notifyMnpFailures = function(pendingOrders){
            if (onPath('/registration/mnp', '/registration/sales')) return;
            var mnpFailures = pendingOrders
                .filter(byState(jim.OrderState.mnp_failed));

            if (mnpFailures.length > 0)
                utils.showInfo('your_mnp_failed__please_check_details', 'mnp-failed');
        };

        self.hideNotifications = function(){
            utils.hideMessage('swap');
            utils.hideMessage('awaiting-orders');
            utils.hideMessage('mnp-failed');
        };

        /**
         * Check if the currently loaded path is one of the given parths.
         */
        var onPath = function(/*... paths*/){
            return [].includes.call(arguments, $location.path());
        };

        var byType = function(type){
            return function(order){
                return order.type === type;
            };
        };

        var byState = function(state){
            return function(order){
                return order.state === state;
            };
        };
    }]);
